import React from 'react'
import {useSelector} from 'react-redux'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import PopupAtom from '../../@atoms/to_layout/popup/popup.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import {RootState} from '../../store_redux'
import {PopupState} from '../../props_reusable'

interface PopupComponentProps extends PopupState {
  cancelButton: () => void | undefined
  okButton: () => void | undefined
}

const PopupComponent: React.FC<PopupComponentProps> = function ({
  open,
  cancelButton,
  okButton,
  type,
}) {
  const labels = useSelector((state: RootState) => state.labels)

  const renderTitle = () => (
    <TypographyAtom ap_type="h6">
      {type === 'cancel_popup'
        ? labels.locationModal.cancelPopup.title
        : labels.locationModal.notAllowedLocationPopup.title}
    </TypographyAtom>
  )

  const renderContent = () => (
    <TypographyAtom ahd_type="sData">
      {type === 'cancel_popup'
        ? labels.locationModal.cancelPopup.content
        : labels.locationModal.notAllowedLocationPopup.content}
    </TypographyAtom>
  )

  const renderActions = () =>
    type === 'cancel_popup' ? (
      <>
        <ButtonAtom ap_type="secondary" onClick={cancelButton}>
          {labels.locationModal.cancelPopup.buttonCancel}
        </ButtonAtom>
        <ButtonAtom ap_type="primary" onClick={okButton}>
          {labels.locationModal.cancelPopup.buttonOk}
        </ButtonAtom>
      </>
    ) : (
      <BoxAtom>
        <ButtonAtom ap_type="secondary" onClick={okButton}>
          {labels.locationModal.notAllowedLocationPopup.buttonClose}
        </ButtonAtom>
      </BoxAtom>
    )

  return open ? (
    <PopupAtom
      open={open}
      ap_name={
        type === 'cancel_popup'
          ? 'edit_location_cancel_popup'
          : 'location_too_far_popup'
      }
      renderActions={renderActions}
      renderContent={renderContent}
      renderTitle={renderTitle}
    />
  ) : null
}

export default PopupComponent
